import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=a0929090&"
import script from "./Agregar.vue?vue&type=script&lang=ts&"
export * from "./Agregar.vue?vue&type=script&lang=ts&"
import style0 from "./Agregar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports